import { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import {
    Badge,
    BadgeColors,
    SecurityLockedIcon
} from "@dotnet/telematics-design-system";

import { BUTTON_COLORS } from "components/DesignComponents/Button/types/enums";
import AuthContext from "context/auth/authContext";

import ContentFrameGroup from "../../ContentFrameGroup";
import DisableTwoFactorAuthentication from "./DisableTwoFactorAuthentication";
import EnableTwoFactorAuthentication from "./EnableTwoFactorAuthentication";

const TwoFactorAuthentication = () => {
    const { user } = useContext(AuthContext);

    const { t } = useTranslation();

    const [isEnableDialogOpen, setIsEnableDialogOpen] = useState(false);
    const [isDisableDialogOpen, setIsDisableDialogOpen] = useState(false);

    const openDialog = () =>
        isEnabled ? setIsDisableDialogOpen(true) : setIsEnableDialogOpen(true);

    const closeDialog = () => {
        setIsEnableDialogOpen(false);
        setIsDisableDialogOpen(false);
    };

    const isEnabled = user?.two_factor_auth_enabled;

    const title = (
        <div
            css={css({
                display: "flex",
                alignItems: "center",
                columnGap: "4px"
            })}
        >
            {t("Security##2FA##settings##title")}

            <Badge
                color={isEnabled ? BadgeColors.success : BadgeColors.neutral}
            >
                {isEnabled
                    ? t("Security##2FA##settings##enabled")
                    : t("Security##2FA##settings##disabled")}
            </Badge>
        </div>
    );

    return (
        <>
            <ContentFrameGroup
                title={title}
                description={t("Security##2FA##settings##description")}
                buttonText={
                    isEnabled ? t("Button##disable") : t("Button##enable")
                }
                buttonColor={BUTTON_COLORS.Secondary}
                icon={<SecurityLockedIcon />}
                onButtonClick={openDialog}
            />

            <EnableTwoFactorAuthentication
                isOpen={isEnableDialogOpen}
                close={closeDialog}
            />

            <DisableTwoFactorAuthentication
                isOpen={isDisableDialogOpen}
                close={closeDialog}
            />
        </>
    );
};

export default TwoFactorAuthentication;
